import { FooterWrapper, ScrollToTop } from "./styled"
import { FaAngleUp, FaBed, FaCarSide, FaGulp, FaUserFriends } from "react-icons/fa";
import { useState, useEffect } from "react";

const Footer = () => {
    const [btnGoTop, setBtnGoTop] = useState(false)

    useEffect(() => {
        const handleScoll = () => {
            if (window.scrollY >= 160) {
                setBtnGoTop(true)
            }
            else {
                setBtnGoTop(false)
            }
        }

        window.addEventListener('scroll', handleScoll)

        //clearnup function
        return () => {
            window.removeEventListener('scroll', handleScoll)
        }
    }, [])

    const handleClickGoTop = () => {
        window.scrollTo(0, 0)
    }

    return (
        <FooterWrapper>
            <div className="grid wide pb-40">
                <div className="mb-100">
                    <div className="text-center text-black medium s-22 mb-20">DỊCH VỤ CỦA CHÚNG TÔI</div>
                    <div className="list_service">
                        <div className="item">
                            <div className="flex title">
                                <FaCarSide style={{ fontSize: "20px" }} className="text-link mr-5" />
                                <h4 className="s-18 text-center text-link mb-0">Di chuyển miễn phí</h4>
                            </div>
                            <div className="s-14 text-black content mt-5">Miễn phí di chuyển cho toàn bộ hành trình của bạn</div>
                        </div>
                        <div className="item">
                            <div className="flex title">
                                <FaBed style={{ fontSize: "20px" }} className="text-link mr-5" />
                                <h4 className="s-18 text-center text-link mb-0">Nghỉ ngơi miễn phí</h4>
                            </div>
                            <div className="s-14 text-black content mt-5">Miễn phí nơi ngủ nghỉ trong suốt tour</div>
                        </div>
                        <div className="item">
                            <div className="flex title">
                                <FaGulp style={{ fontSize: "20px" }} className="text-link mr-5" />
                                <h4 className="s-18 text-center text-link mb-0"> Ăn uống miễn phí</h4>
                            </div >
                            <div className="s-14 text-black content mt-5">Bao trọn bữa ăn bằng những món đặc sản tại nơi du lịch</div>
                        </div>
                        <div className="item">
                            <div className="flex title">
                                <FaUserFriends style={{ fontSize: "20px" }} className="text-link mr-5" />
                                <h4 className="s-18 text-center text-link mb-0">Hướng dẫn viên miễn phí</h4>
                            </div>
                            <div className="s-14 text-black content mt-5">Hướng dẫn viên tại mỗi điểm đến thăm quan</div>
                        </div>
                    </div>
                </div>
                <div className="main">
                    <h3>Bản quyền © 2022 bởi Travel With Me</h3>
                    <p>Công ty Cổ Phần Travel With Me Việt Nam Giấy phép kinh doanh số 0107875xxx do sở kế hoạch và đầu tư thành phố Hồ Chí Minh cấp ngày 06/06/2016

                        Văn phòng HCM: 319 - C16 Lý Thường Kiệt, phường 15, quận 11, Ha Noi

                        Hotline :1900 636 6a48 | Email: travelwithme@gmail.media</p>
                </div>
            </div>
            {
                btnGoTop &&
                <ScrollToTop onClick={handleClickGoTop}>
                    <i><FaAngleUp /></i>
                </ScrollToTop>
            }
        </FooterWrapper>
    )
}

export default Footer